export default {
    getStoredWarningById: (state) => (id) => {
        const warning = state.warnings.find(warning => warning.id === id)
        if (warning === undefined) {
            state.warnings.push({ id: id })
            return state.warnings.find(warning => warning.id === id)
        } else {
            return warning
        }
    },
    getStoredWarnings: (state) => {
        return state.warnings
    },
    getWarningPages: state => {
        return state.warning_pages
    },
    getNewWarning: (state) => {
        return state.newWarning
    }
}
